import {Component, ViewEncapsulation} from "@angular/core";
import {FormBuilder, FormGroup, Validators} from "@angular/forms";
import {ApiService} from "../../service/api";
import {ActivatedRoute, Router} from "@angular/router";
import swal from "sweetalert2";

@Component({
    selector: 'fw-register-code',
    templateUrl: './code.html',
    encapsulation: ViewEncapsulation.None
})
export class RegisterCodeComponent {

    public form: FormGroup;

    constructor(public fb: FormBuilder,
                public apiService: ApiService,
                public nav: Router,
                public route: ActivatedRoute) {
        this.form = this.fb.group({
            code: ['', [Validators.required]]
        });

        this.route.paramMap.subscribe((params) => {
            this.form.patchValue({code: params.get('code')});
        });
    }

    public code($event) {
        this.apiService.call('/contact/index/code', this.form.getRawValue()).then((result) => {
            swal({
                title: 'Erfolgreich',
                text: 'Die Registrierung wurde abgeschlossen! Sie können Sich nun einloggen!',
                type: 'success'
            })

            this.nav.navigate(['/home']);
        }).catch((result) => {
            let message = JSON.parse(result.statusText);
            swal({
                title: message.title,
                text: message.message,
                type: 'warning'
            })
        });
    }

}


// WEBPACK FOOTER //
// ./src/app/pages/register/code.ts